import request from '@/utils/request'


export function getIndex(data) {
  return request({
    url: 'goods/getIndex',
    method: 'get',
    params: data
  })
}